<script setup lang="ts">
import { ref } from "vue";
import {
  TooltipProvider,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "./index";

export interface PandoTooltipProps {
  content: string;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
  delayDuration?: number;
  disableHoverableContent?: boolean;
  disabled?: boolean;
  triggerAsChild?: boolean;
  contentClass?: string;
}

const props = withDefaults(defineProps<PandoTooltipProps>(), {
  side: "top",
  align: "center",
  delayDuration: 200,
  disableHoverableContent: false,
  disabled: false,
  triggerAsChild: true,
});

const isOpen = ref(false);

const handleOpenChange = (open: boolean) => {
  if (!props.disabled) {
    isOpen.value = open;
  }
};
</script>

<template>
  <TooltipProvider
    :delayDuration="delayDuration"
    :disableHoverableContent="disableHoverableContent"
  >
    <Tooltip
      :open="disabled ? false : undefined"
      @update:open="handleOpenChange"
    >
      <TooltipTrigger :asChild="triggerAsChild" :disabled="disabled">
        <slot />
      </TooltipTrigger>
      <TooltipContent
        v-if="!disabled"
        :side="side"
        :align="align"
        :class="contentClass"
      >
        {{ content }}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>
